export function formatDate(date,options=null){
  const res = new Date(date)
  return res.toLocaleDateString('en-GB')
}